module.exports = __webpack_public_path__ + "media/brand_logos/ogilvy-fb3ad8b7.png";